import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment'; 
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Checkbox, Grid, 
         Paper, TextField, Typography,
         Table, TableHead, TableBody, TableCell, TableRow
} from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import AppBindStyles from '../../AppBindStyles';

import LandingPreviewDialog from './LandingPreviewDialog';
import LandingPreview from './LandingPreview';

import ConfirmationDialog from '../ui/ConfirmationDialog';
import PageTitle from '../ui/PageTitle';
import SaveButton from '../ui/SaveButton';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import EnvironmentDefs from '../../EnvironmentDefs';
import { disableAttributeCheck, isValidURL } from '../../utils/InputUtils';

const envDefs = new EnvironmentDefs();

const abEnvironment = new AbEnvironment();
const LandingPageEditQuery = graphql`
query LandingPageEditQuery($accountLandingId: UUID!) {
  accountLandingTByAccountLandingId(accountLandingId: $accountLandingId) {
    accountTByAccountId {
      logo
      accountPath
      appTsByAccountId(orderBy:APP_NAME_ASC) {
        totalCount
        nodes {
           appId
           appName
           appSku
           appStatus
           cpAppTsByAppId {
            totalCount
            nodes {
              cpId
              cpTByCpId {
                programName
              }
            }
          }
        }
      }
    }
    accountLandingId
    landingPath
    landingName
    landingText
    landingTitle
    logo
    partnerLink
    partnerLinkText
    signupText
    accountPackageId       
    accountPackageTByAccountPackageId {
      parmValue
      accountPackageAppTsByAccountPackageId {
        nodes {
         appId
         accountPackageId
         accountPackageAppId
         appTByAppId {
            appName
            appSku
            appStatus
             cpAppTsByAppId {
              totalCount
              nodes {
                cpId
                cpTByCpId {
                  programName
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    sectionTitle: {
      marginBottom: 0
    },
    previewButton: {
      marginTop: 8,
      marginBottom: 8,
      marginRight: 0
    },
    formControl: {
      marginTop: -8
    },
  });
  
  class LandingPageEdit extends Component {
    state = {
      landingPath: null,
      landingName: null,
      landingTitle: null,
      landingText: null,
      signupText: null,
      partnerLink: null,
      partnerLinkText: null,
      logo: null,
      pId: null,
      appSelections: [],
      noAppsDefined: true,

      saveStatus:           null,
      saveMessage:          null,
      saveSnackbarOpen:     false,
      saveSnackbarDuration: null,
      saveClicked:          true,
      confirmDelete:        false,
      showPreview:          false

    }

    componentDidMount() {
      if (abEnvironment.isSegmentActive()) {  window.analytics.track('Editing a landing page'); }
    }
  
    goTo(route) {
      this.props.history.push(`/${route}`);
    }

    goBack() {
      this.props.history.goBack();
    }
    
    getValueForRender(state_member, prop_member, theDefault) {
      if (state_member != null)
        return state_member;
      
      if (prop_member != null)
        return prop_member;
  
      return theDefault;
    }

    updateAppSelection = (appChanged, packageAppTNodes) => {
      let mutableArray = [];
      let i = 0;    
      let found = false;
      for (i = 0; i < this.state.appSelections.length; i++) {
        let app = this.state.appSelections[i];
        if (app.appId === appChanged.appId) {
          app.selected = !app.selected;
          found = true;
        } 
        mutableArray.push(app);
      }
  
      if (!found) {
        let appName = '';
        if (appChanged.appSku == null || appChanged.appSku === '') {
          appName = appChanged.appName;
        } else {
          appName = appChanged.appName + " (" + appChanged.appSku + ")";
        }
        let programName = appChanged.programName;
        let cpId = appChanged.cpId;


        let packageAppId = null;

        for (i = 0; i < packageAppTNodes.length; i++) {
          let appT = packageAppTNodes[i]
          if (appT.appId === appChanged.appId) {
            packageAppId = appT.accountPackageAppId;
          } 
        }
        let selected = false;
        if (packageAppId !== null) {
          selected = false;
        } else {
          selected = !selected;
        }  

        let appSelection = {'accountPackageAppId' : packageAppId, 'appId' : appChanged.appId, 'appName': appName, 'selected' : selected, 'cpId' : cpId, 'programName': programName};      
        mutableArray.push(appSelection);
      }
  
      this.setState({appSelections: mutableArray});
    }
    
    isLandingPathInError = () => {
      if (!this.state.saveClicked) {
        return '';
      }
  
      if (this.state.landingPath === null) {
        //this means it was not changed....
        return '';
      }

      if (this.isRequiredFieldInError(this.state.landingPath) !== '') {
        return this.isRequiredFieldInError(this.state.landingPath);
      }
  
      if (this.state.landingPath.indexOf(' ') >= 0) {
        return 'Field cannot have spaces'
      }
  
      return '';
    }

    isRequiredFieldInError = (state_member) => {
      if ((state_member === '') && (this.state.saveClicked)) {
        return 'Field is required';
      } else {
        return '';
      }
    }

    isAppSelectionInError = (accountPkgApps) => {
      // if saved has been clicked, see if one app is selected.
  
      if (this.state.appSelections.length === 0) {
        return false;
      }
      if (this.state.appSelections.length < accountPkgApps.length) {
        return false;
      }
 

      if (this.state.appSelections.length !== accountPkgApps.length || this.state.appSelections.length === accountPkgApps.length) {
        let i = 0;
  
        for (i = 0; i < this.state.appSelections.length; i++) {
          let appT = this.state.appSelections[i]
          if (appT.selected === true) {
            return false;
          }
        }
  
      }

      return true;
    }

    isAppSelected = (appId, packageAppTNodes) => {
      // if saved has been clicked, see if one app is selected.
      let i = 0;
      for (i = 0; i < this.state.appSelections.length; i++) {
        let appT = this.state.appSelections[i]
        if (appT.appId === appId) {
          return appT.selected;
        }
      }

      //if it got here, the apps state has not changed, see if it is in existing packageApp nodes
      if (this.isAppSelectedInDB (appId, packageAppTNodes) !== null) {
        return true;
      }

      return false;
    }

    isAppSelectedInDB = (appId, packageAppTNodes) => {
      // if saved has been clicked, see if one app is selected.
      let i = 0;

      //if it got here, the apps state has not changed, see if it is in existing packageApp nodes
      for (i = 0; i < packageAppTNodes.length; i++) {
        let appT = packageAppTNodes[i]
        if (appT.appId === appId) {
          return appT.accountPackageAppId;
        } 
      }
      return null;
    }

    disablePreview(accountLanding, accountPkgApps) {
      if (this.isLandingPathInError() !== '')
        return true;

      if ((this.state.landingName !== null) && this.state.landingName === '')
        return true;

      if (this.isAppSelectionInError(accountPkgApps))
        return true;

      if (isValidURL(this.state.partnerLink) !== '') 
        return true;

      return false;
    }

    disableSave(accountLanding, accountPkgApps) {
      if (this.isLandingPathInError() !== '')
        return true;

      if ((this.state.landingName !== null) && this.state.landingName === '')
        return true;

      if (isValidURL(this.state.partnerLink) !== '') 
        return true;

      if (this.isAppSelectionInError(accountPkgApps))
        return true;
  
 
      let retval = disableAttributeCheck(this.state.landingPath,      accountLanding.landingPath) &&
                   disableAttributeCheck(this.state.landingName,      accountLanding.landingName) &&
                   disableAttributeCheck(this.state.landingTitle,     accountLanding.landingTitle) &&
                   disableAttributeCheck(this.state.landingText,      accountLanding.landingText) &&
                   disableAttributeCheck(this.state.signupText,       accountLanding.signupText) &&
                   disableAttributeCheck(this.state.partnerLink,      accountLanding.partnerLink) &&
                   disableAttributeCheck(this.state.partnerLinkText,  accountLanding.partnerLinkText) &&
                   disableAttributeCheck(this.state.logo,             accountLanding.logo) ;
 
      if (!retval) {
        return retval;
      }

      //see if any of the app selections have changed
      let i = 0;
      for (i = 0; i < this.state.appSelections.length; i++) {
        let app = this.state.appSelections[i];
        let appInDB = null; 
        let y = 0;
        for (y = 0; y < accountPkgApps.length; y++) {
          let existingApp = accountPkgApps[y];
          if (app.appId === existingApp.appId) {
            appInDB = existingApp;
            break;
          }  
        }

        if (appInDB === null && app.selected === true) {
          //user selected new app
          return false;
        } else if (appInDB !== null && app.selected === false) {
          return false;
        }

      }
      
      return true;
    }

    handlePreviewDialogClose = () => {
      this.setState({showPreview: false});
    };
      
    getSignupUrl = (accountPath, accountLanding) => {
      let signupUrl = null;
      if (envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc") {
          signupUrl = "https://poc.appbind.com/signup/" + accountPath + "/" + this.getValueForRender(this.state.landingPath,  accountLanding.landingPath, '');
      } else if (envDefs.getEnv() !== "poc" && envDefs.getEnv() !== "devpoc") {
          signupUrl = "https://app.appbind.com/signup/" + accountPath + "/" + this.getValueForRender(this.state.landingPath,  accountLanding.landingPath, '');
      }

      return signupUrl;
    }

    getRegisterUrl = (accountPath, accountLanding) => {
      let signupUrl = null;
      if (envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc") {
          signupUrl = "https://poc.appbind.com/register/" + accountPath + "/" + this.getValueForRender(this.state.landingPath,  accountLanding.landingPath, '');
      } else if (envDefs.getEnv() !== "poc" && envDefs.getEnv() !== "devpoc") {
          signupUrl = "https://app.appbind.com/register/" + accountPath + "/" + this.getValueForRender(this.state.landingPath,  accountLanding.landingPath, '');
      }

      return signupUrl;
    }

    render() {
        const { isAuthenticated, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
        const classes = this.props.classes;

        let appCounter = 0;
    
        if (!isAuthenticated() || needAssent()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedVendor()) {
          const params = new URLSearchParams(this.props.location.search);

          let accountLandingId = params.get('accountLandingId');

          return (
            <QueryRenderer
              environment={abEnvironment.getEnvironment()}
              query={LandingPageEditQuery}
              variables={{accountLandingId: accountLandingId}}
              render={({error, props})=> {
                if (error) {
                  logError(error.message);
                  return (
                    <ServerError/>
                  );
                } else if (props) {
                  let accountLanding = props.accountLandingTByAccountLandingId;

                  if (accountLanding === null) {
                    return (
                      <PageTitle title="Landing page not found" showBackButton={true} name="landing pages" history={this.props.history}/>
                    );
                  }
      
                  let accountLogo = accountLanding.accountTByAccountId.logo;

                  let accountPackageId = accountLanding.accountPackageId;

                  let accountPkgApps = accountLanding.accountPackageTByAccountPackageId.accountPackageAppTsByAccountPackageId.nodes

                  let thePv = null;
                  if (accountLanding.accountPackageTByAccountPackageId.parmValue != null &&
                      accountLanding.accountPackageTByAccountPackageId.parmValue !== '') {
                    thePv = accountLanding.accountPackageTByAccountPackageId.parmValue;
                  }

                  let apps = [];
                  let i = 0;
                  for (i = 0; i < accountLanding.accountTByAccountId.appTsByAccountId.nodes.length; i++) {
                    let app = accountLanding.accountTByAccountId.appTsByAccountId.nodes[i];

                    let appName = '';
                    if (app.appSku == null || app.appSku === '') {
                      appName = app.appName;
                    } else {
                      appName = app.appName + " (" + app.appSku + ")";
                    }
          
                    let programName = 'This app is not in a commission plan';
                    let cpId = null;
                    if (app.cpAppTsByAppId.totalCount > 0) {
                      cpId = app.cpAppTsByAppId.nodes[0].cpId;
                      programName = app.cpAppTsByAppId.nodes[0].cpTByCpId.programName;
                    }

                    let appPackageEntry = null;
                    let existing = false;
                    let y = 0;
                    for (y = 0; y < accountPkgApps.length; y++) {
                      appPackageEntry = accountPkgApps[y];
                      if (appPackageEntry.appId === app.appId) {
                        if (appPackageEntry.appTByAppId.cpAppTsByAppId.totalCount > 0) {
                          cpId = appPackageEntry.appTByAppId.cpAppTsByAppId.nodes[0].cpId;
                          programName = appPackageEntry.appTByAppId.cpAppTsByAppId.nodes[0].cpTByCpId.programName;
                        }

                        let appSelection = {
                          'accountPackageAppId' : appPackageEntry.accountPackageId, 
                          'appId' : app.appId, 
                          'appName': appName, 
                          'selected' : this.isAppSelected(app.appId, accountPkgApps),
                          'cpId' : cpId,
                          'programName': programName
                        };
                        apps.push(appSelection);
                        existing = true;
                        break;
                      }
                    }
                    if (!existing) {
                      let appSelection = {
                        'accountPackageAppId' : null, 
                        'appId' : app.appId, 
                        'appName': appName, 
                        'selected' : this.isAppSelected(app.appId, accountPkgApps),
                        'cpId' : cpId,
                        'programName': programName
                      };
                      apps.push(appSelection);
                    }
                  }
                  
                  return (
                    <Grid container spacing={3} direction="row" justifyContent="flex-start">
                      <Grid item xs={12}>
                        <PageTitle title="Create your own signup link" subtitle="Encourage partners to sign up for your reseller programs from within your own landing pages, email marketing, or partner portal. Just use this sign up link." showBackButton={true} name="landing pages" noMargin={true} history={this.props.history}/>
                      </Grid>
                      <Grid item xs={12}>
                        <Paper className={classes.paper}>
                          <Grid container spacing={2} direction="row" justifyContent="space-between">
                            <Grid item xs={12}>
                              <Grid container spacing={0} className={classes.sectionTitle} direction="column" justifyContent="flex-start">
                                <Grid item>
                                  <Typography variant="h6">Sign up link</Typography>
                                </Grid>
                                <Grid item>
                                  <Typography variant="body2"><strong>{this.getSignupUrl(accountLanding.accountTByAccountId.accountPath, accountLanding)}</strong></Typography>
                                </Grid>
                                <Grid item>
                                  <Typography variant="body2"><strong>{this.getRegisterUrl(accountLanding.accountTByAccountId.accountPath, accountLanding)}</strong> (existing AppBind accounts)</Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                error={this.isLandingPathInError() !== ''}
                                id="landing-path" label="Link path *"
                                value={this.getValueForRender(this.state.landingPath,  accountLanding.landingPath, '')}
                                onChange={(e) => this.setState({ landingPath: e.target.value })}
                                inputProps={{ maxLength: 32 }}
                                helperText={this.isLandingPathInError()}          
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                error={this.isRequiredFieldInError(this.state.landingName) !== ''}
                                id="landing-name" label="Link name *"
                                value={this.getValueForRender(this.state.landingName,  accountLanding.landingName, '')}
                                onChange={(e) => this.setState({ landingName: e.target.value })} 
                                inputProps={{ maxLength: 32 }}
                                helperText={this.isRequiredFieldInError(this.state.landingName)}/>
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container spacing={0} className={classes.sectionTitle} direction="column" justifyContent="flex-start">
                                <Grid item>
                                  <Typography variant="h6">Set up apps and commissions</Typography>
                                </Grid>
                                <Grid item>
                                  <Typography variant="body2">What apps will be added as defaults for approved partners signing up through this page?</Typography>
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* Apps in form control */}
                            {/* 
                            <Grid item xs={12} md={6}>
                              <FormControl error={this.isAppSelectionInError()} component="fieldset" className={classes.formControl}>
                                <InputLabel shrink htmlFor="apps">Apps</InputLabel>
                                <FormGroup style={{marginTop: '8px'}}>
                                  { this.state.appSelections.map(n => {
                                    return (<FormControlLabel  key={(appCounter++).toString()}
                                        control={<Checkbox checked={n.selected} onChange={() => this.updateAppSelection(n.appId)} />}
                                        label={n.appName}
                                    />);
                                  })}
                                </FormGroup>
                                {this.isAppSelectionInError() &&
                                <FormHelperText>At least one app must be selected</FormHelperText>}
                              </FormControl>
                            </Grid>
                            */}

                            {/* Apps in table */}
                            <Grid item xs={12}>
                              <Paper>
                                <Table>
                                  <TableHead style={AppBindStyles.tableHead}>
                                    <TableRow style={AppBindStyles.tableHeadRow}>
                                      <TableCell/>
                                      <TableCell>App</TableCell>
                                      <TableCell>Commission plan</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                  { apps.map(n => {
                                    return (
                                      <TableRow key={(appCounter++).toString()}>
                                        <TableCell>
                                          <Checkbox checked={n.selected} onChange={() => this.updateAppSelection(n, accountPkgApps)} />
                                        </TableCell>
                                        <TableCell>{n.appName}</TableCell>
                                        <TableCell>{n.programName}</TableCell>
                                      </TableRow>
                                    );
                                  })}
                                  </TableBody>
                                </Table>
                              </Paper>
                            </Grid>

                          </Grid>

                          <Grid container direction="row" justifyContent="space-between" style={{marginTop: '8px'}}>
                            <Grid item>
                              <SaveButton
                                snackbarOpen={this.state.saveSnackbarOpen}
                                autoHideDuration={this.state.saveSnackbarDuration}
                                status={this.state.saveStatus} 
                                message={this.state.saveMessage}
                                disabled={this.disableSave(accountLanding, accountPkgApps)} 
                                onSaveClick={() => {this.updateLandingTables(accountLandingId, accountPackageId)}}
                                onSnackbarClose={() => { this.onSnackbarClose(); }}
                              />                        

                              <Button variant="outlined" color="primary" style={AppBindStyles.bottomButton} onClick={() => { this.setState({confirmDelete:true}); }}>
                                <Delete color="primary"/> Delete
                              </Button>
                              <ConfirmationDialog
                                  open={this.state.confirmDelete}
                                  onClose={() => { this.setState({confirmDelete:false});}}
                                  onConfirm={() => { this._deleteLandingTables(accountLandingId, accountPackageId, accountPkgApps); }}
                                  onCancel={() => { }}
                                  title="Delete landing page?"
                                  cancelBtn="Cancel"
                                  okBtn="Ok"
                                >
                                  If you delete this landing page, the associated url will no longer resolve.  Are you sure you want to proceed?
                              </ConfirmationDialog>  
                            
                            </Grid>
                          </Grid>
                        </Paper>

                        <LandingPreviewDialog
                          title="Landing Page Preview"
                          open={this.state.showPreview}
                          onClose={() => { this.handlePreviewDialogClose()}} >

                            <LandingPreview
                              landingLogo={this.getValueForRender(this.state.logo,  accountLanding.logo, accountLogo)}
                              landingName={this.getValueForRender(this.state.landingName,  accountLanding.landingName, '')}
                              landingTitle={this.getValueForRender(this.state.landingTitle,  accountLanding.landingTitle, '')}
                              landingText={this.getValueForRender(this.state.landingText,  accountLanding.landingText, '')}
                              signupText={this.getValueForRender(this.state.signupText,  accountLanding.signupText, '')}
                              partnerLink={this.getValueForRender(this.state.partnerLink,  accountLanding.partnerLink, '')}
                              partnerLinkText={this.getValueForRender(this.state.partnerLinkText,  accountLanding.partnerLinkText, '')}
                              linkParameter={this.getValueForRender(this.state.landingPath,  accountLanding.landingPath, '')}
                      
                              onClose={() => { this.handlePreviewDialogClose()}}>
                            </LandingPreview>
                        </LandingPreviewDialog>
                      </Grid>
                    </Grid>
                  );
                }
                return <LoadingSpinner />
              }}
            />
          )
        } else {
          return (
            <Redirect to='/home' />
          );
        }
    }

    onSnackbarClose() {
      this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
    }
    
    updateLandingTables = (accountLandingId, accountPackageId) => {
        
        this.setState({ saveStatus: 'saving' });
    
        const { callPartnerApi } = this.props.auth;
    
        let accountId = abEnvironment.getUserAttribute('a_id');
        let aPjwt = abEnvironment.getPjwt();
        let success = false;
    
        //get all the selected apps
        let i = 0;
        let appsToAdd = [];
        let appToAdd = {};
        for (i = 0; i < this.state.appSelections.length; i++) {
          let app = this.state.appSelections[i];
          if (app.selected === true) {
            appToAdd = {
              "accountPackageAppId": app.accountPackageAppId,
              "appId": app.appId,
              "appMarkupPercentage": "0.0",
              "paymentOrder": 0,
              "selected": true
            };
            appsToAdd.push(appToAdd);
          }  else {
            appToAdd = {
              "accountPackageAppId": app.accountPackageAppId,
              "appId": app.appId,
              "appMarkupPercentage": "0.0",
              "paymentOrder": 0,
              "selected": false
            };
            appsToAdd.push(appToAdd);

          }
        }
    
        // For the purpose of the landing page, parmValue (what goes on account_package) will always
        // be the same as the landingPath (end path part for this landing page)
        let theBody = {
          "accountLandingId": accountLandingId,
          "accountPackageId": accountPackageId,
          "accountId": accountId,
          "landingPath": this.state.landingPath,
          "landingName": this.state.landingName,
          "logo": this.state.logo,
          "landingTitle": this.state.landingTitle,
          "landingText": this.state.landingText,
          "signupText": this.state.signupText,
          "partnerLink": this.state.partnerLink,
          "partnerLinkText": this.state.partnerLinkText,
          "parmValue": this.state.landingPath, 
          "programId": this.state.pId, 
          "apps": appsToAdd
        };
    
        let payload = {
          operation: "updateVendorAccountLanding",
          params: {
            pJwt:             aPjwt,
            accountId:        accountId,
            body:             theBody
          }
        }
         
        callPartnerApi('appbind/generic',
                       'POST',
                       payload
        ).then((response) => {
          if (response.status === 200) {
            success = true;
          }
          return response.json();
        })
        .then(response => {
          if (success) {
    
            this.setState({ saveStatus: 'success' });
            this.goBack();
          } else {
    
            let theMessage = 'Unable to save landing page';  //default
            if (response.err != null) {
              theMessage = response.err.errMessage;  //more specific
            }
            this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: theMessage, saveSnackbarDuration: null });
          }
        })
        .catch(error => {
          this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save landing page', saveSnackbarDuration: null });
        });
     }


    _deleteLandingTables = (accountLandingId, accountPackageId, accountPkgApps) => {

      this.setState({ saveStatus: 'saving' });

      const { callPartnerApi } = this.props.auth;
  
      let accountId = abEnvironment.getUserAttribute('a_id');
      let aPjwt = abEnvironment.getPjwt();
      let success = false;
  
  
      //get all the selected apps
      let i = 0;
      let appsToDelete = [];
      let appToDelete = {};
      for (i = 0; i < accountPkgApps.length; i++) {
        let app = accountPkgApps[i];
        if (app.accountPackageAppId) {
          appToDelete = {
            "accountPackageAppId": app.accountPackageAppId,
          };
          appsToDelete.push(appToDelete);
        } 
      }
  
      //TODO is parm value always landing path?
      //construct the complete body
      let theBody = {
        "accountLandingId": accountLandingId,
        "accountPackageId": accountPackageId,
        "accountId": accountId,
        "apps": appsToDelete
      };
    
      let payload = {
        operation: "deleteVendorAccountLanding",
        params: {
          pJwt:             aPjwt,
          accountId:        accountId,
          body:             theBody
        }
      }
       
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      ).then((response) => {
        if (response.status === 200) {
          success = true;
        }
        return response.json();
      })
      .then(response => {
        if (success) {
  
          this.setState({ saveStatus: 'success' });
          this.goBack();
        } else {
  
          let theMessage = 'Unable to delete landing page';  //default
          if (response.err != null) {
            theMessage = response.err.errMessage;  //more specific
          }
          this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: theMessage, saveSnackbarDuration: null });
        }
      })
      .catch(error => {
        this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to delete landing page', saveSnackbarDuration: null });
      });
    }
}

LandingPageEdit.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(LandingPageEdit);
